<template>
    <div class='xtx-carousel'>
        <div class="carousel-div">

        <!-- 图片容器 -->
        <ul  ref='carouselBody' class="carousel-body">
          <div v-if="$store.state.notListData" class="nomatch">
               No matched scan
           </div>
           <div v-else>
             <!-- fade显示的图片加上 -->
             <li class="carousel-item" v-for="(item,i) in sliceData.list" :key="i" :class="{fade:imgIndex===i}">
                <!-- <div  v-if="item.imgUrl.includes('blob:')"> -->
                <div  v-if="item.url">
                    <img-mark v-if="imgIndex===i"
                     ref="img" :img="item.url" :styleList="styleList" :drawData="drawData" :dataList="item.drawList"
                    :scanIndex="$store.state.scanIndex"
                    :index="$store.state.sliceIndex"
                    :imgStyle="item.styleImg"
                     :markList="item.markList"
                     :itemIndex="i"
                     ></img-mark>
                </div>
                <div v-else>
                <el-skeleton class="carousel-skeleton" :loading="loading" animated>
                    <template #template>
                    <el-skeleton-item  variant="image" class="carousel-skeleton" />
                    </template>
                </el-skeleton>
                </div>
            </li>
           </div>

        </ul>
    </div>
  </div>
</template>

<script>
import imgMark from '@/components/imgMark.vue'
// import { getImgStyle } from '@/utils/index.js'
export default {
  name: 'Carousel',
  components: {
    imgMark
  },
  props: {
    imgHeight: {
      type: Number,
      default: 500
    },
    imgWidth: {
      type: Number,
      default: 500
    },
    imgIndex: {
      type: Number,
      default: 0
    },
    sliceData: {
      type: Object,
      default: () => {}
    },
    drawData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    // sliceData: {
    //   handler (newval, oldval) {
    //   },
    //   deep: true
    // }
  },
  data () {
    return {
      index: 0,
      datalist: [],
      width: this.imgWidth,
      height: this.imgHeight
    }
  },
  computed: {
    styleList () {
      const obj = {
        width: this.imgWidth,
        height: this.imgHeight
      }
      return obj
    }
  },
  mounted () {
    // this.datalist = this.sliceData.list[0].drawList
    console.log(this.sliceData)
    console.log(this.$store.state.list)
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.xtx-carousel{
    width: 100%;
    height: 100%;
    min-width: 300px;
    min-height: 150px;
    position: relative;
 }
 .carousel-div{
    display: flex;
    height: 100%;
 }
 .carousel-text{
    width: 180px;
    height: 200px;
    z-index: 100;
    position: absolute;
    top:0;
    left: 0;
    /* background-color: #fff; */

 }
 .carousel-text-div{
    width: auto;
    margin: 5px 12px;
 }
 .carousel-text-div div:first-child{
    height: 30px;
    font-size: 16px;
    color: #ffffff;
    background-color: #4F4F4F;
    line-height: 30px;
    padding-left: 5px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
 }
 .carousel-text-div div:last-child{
    height: 92px;
    font-size: 16px;
    color: #ffffff;
    padding-left: 5px;
    line-height: 30px;
    background-color: #131313;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
 }

 .carousel-body{
        flex: 1;
        /* width: 100%; */
        /* height: 100%; */
        padding:0;
        margin: 0;
        background-color: #050608;
 }
 .carousel-item{
        width: 100%;
        height: 100%;
        /* // max-height: 1100px; */
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        transition: opacity 0.5s linear;
        list-style-type: none;
 }
 .nomatch{
   position: absolute;
   top:50%;
   left:50%;
   transform: translate(-50%;-50%);
   color:#ffffff;
   font-size: 18px;
 }
.fade {
    opacity: 1;
    z-index: 1;
}
.carousel-item  img {
          display: block;
        //   max-width: 100%;
        //   width:70%;
          /* height: 100%; */
          /* // max-width: 1100px; */
          /* max-height: 700px; */
          margin: 0 auto;
}
.carousel-skeleton{
          width: 1150px;
          height: 700px;
        }
.carousel-indicator {
    position: absolute;
    left: 0;
    bottom: 20px;
    z-index: 2;
    width: 100%;
    text-align: center;
}
.carousel-indicator span {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: rgba(0,0,0,0.2);
    border-radius: 50%;
    cursor: pointer;
    /* ~ span {
    margin-left: 12px;
    } */
}
.carousel-indicator  span .active {
    background:  #fff;
}
.carousel-span{
        width: 44px;
        height: 44px;
        color: #ffffff;
        font-size: 20px;
        position: absolute;
        /* // top: 228px; */
        /* top:-60px; */
        bottom: 20px;
        z-index: 2;
        text-align: center;
        line-height: 44px;
        opacity: 1;
        left: 48%;
        background-color: #4F4F4F;
        padding: 2px 10px;
        border-radius: 8px;
}
.carousel-btn {
    width: 44px;
    height: 44px;
    /* background: rgba(0,0,0,.2); */
    /* color: #000000; */
    /* border-radius: 50%; */
    position: absolute;
    top: 45%;
    z-index: 2;
    text-align: center;
    line-height: 44px;
    opacity: 1;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    font-size: 49px;
    color:#ffffff;
}
.prev{
    left: 2%;
}
.next{
    right: 2%;
}
</style>
